(function(){
  if (window.__ilevFlash) return; window.__ilevFlash = true;

  // ---------------------------------------------------------------
  // Marca para apagar la ruleta en este navegador.
  // NO se pone al visitar las paginas del regalo: esas se apagan
  // pagina por pagina desde la seccion, y el resto del sitio sigue
  // mostrando la ruleta normal.
  // La ponen: ?ruleta=no (a mano) y la exclusion por lista de Klaviyo
  // de mas abajo. ?ruleta=si la borra.
  // La clave lleva el nombre de la campana: una ruleta futura no
  // hereda la marca de esta.
  // ---------------------------------------------------------------
  var MARCA = 'ilev_sin_ruleta_flash2026';
  function marcado(){ try{ return localStorage.getItem(MARCA) === '1'; }catch(e){ return false; } }
  function marcar(){ try{ localStorage.setItem(MARCA, '1'); }catch(e){} }
  try{
    var _q = new URLSearchParams(location.search);
    if (_q.get('ruleta') === 'si'){ localStorage.removeItem(MARCA); }
    else if (_q.get('ruleta') === 'no'){ marcar(); }
  }catch(e){}
  if (marcado()) return;

  // ---------------------------------------------------------------
  // AJUSTES RAPIDOS: cambia solo estos dos numeros
  var SEGUNDOS_ANTES_DEL_POPUP = 12;  // cuanto espera antes de aparecer
  var HORAS_SIN_MOLESTAR       = 6;   // si lo cierran sin girar, cuanto tarda en volver a abrirse sola
  // ---------------------------------------------------------------

  // Fecha que muestra el contador: medianoche del 2026-09-07 (23:59:59 hora de Chile).
  // Chile entra en horario de verano el 6-sep-2026, por eso el desfase es UTC-3 (no UTC-4).
  //
  // OJO: esta fecha NO apaga nada. Cuando se cumple, solo desaparece el contador;
  // el popup, el banner y el cupon siguen funcionando hasta que se cierre a mano
  // (quitando la seccion "Ruleta Flash ILEV" del grupo Footer en el editor de temas).
  var END       = Date.UTC(2026, 8, 8, 2, 59, 59);
  var KEY       = 'ilev_flash_ago2026';
  var KLAVIYO   = 'WpM2VY';
  var LIST      = 'Ui3jFX';

  function store(k, v){ try{ if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); }catch(e){ return null; } }

  var overlay = document.getElementById('ilev-overlay');
  var card    = document.getElementById('ilev-card');
  var banner  = document.getElementById('ilev-banner');
  var g       = document.getElementById('ilev-wheel-g');
  var fab     = document.getElementById('ilev-fab');
  if (!overlay || !g) return;

  var SEG = [
    {t:['20%','OFF'],       s:29, bg:'#2A2927', fg:'#FFFFFF', win:true },
    {t:['10%','OFF'],       s:29, bg:'#EDC2B4', fg:'#2A2927', win:false},
    {t:['15%','OFF'],       s:29, bg:'#5FB9C6', fg:'#2A2927', win:false},
    {t:['PRUEBA','DE NUEVO'],s:17, bg:'#B2B4DF', fg:'#2A2927', win:false},
    {t:['20%','OFF'],       s:29, bg:'#2A2927', fg:'#FFFFFF', win:true },
    {t:['5%','OFF'],        s:29, bg:'#EDC2B4', fg:'#2A2927', win:false},
    {t:['10%','OFF'],       s:29, bg:'#5FB9C6', fg:'#2A2927', win:false},
    {t:['15%','OFF'],       s:29, bg:'#B2B4DF', fg:'#2A2927', win:false}
  ];
  var N = SEG.length, ARC = 360 / N, NS = 'http://www.w3.org/2000/svg', R = 186;
  var WIN = []; SEG.forEach(function(s,i){ if (s.win) WIN.push(i); });

  function pt(a, r){ var t = (a - 90) * Math.PI / 180; return [200 + r*Math.cos(t), 200 + r*Math.sin(t)]; }

  SEG.forEach(function(seg, i){
    var p0 = pt(i*ARC, R), p1 = pt((i+1)*ARC, R);
    var path = document.createElementNS(NS, 'path');
    path.setAttribute('d','M 200 200 L '+p0[0].toFixed(2)+' '+p0[1].toFixed(2)+' A '+R+' '+R+' 0 0 1 '+p1[0].toFixed(2)+' '+p1[1].toFixed(2)+' Z');
    path.setAttribute('fill', seg.bg);
    path.setAttribute('stroke', '#191F2B');
    path.setAttribute('stroke-width', '3');
    g.appendChild(path);

    var mid = i*ARC + ARC/2, tp = pt(mid, R*0.60);
    var txt = document.createElementNS(NS, 'text');
    txt.setAttribute('x', tp[0].toFixed(2)); txt.setAttribute('y', tp[1].toFixed(2));
    txt.setAttribute('fill', seg.fg); txt.setAttribute('text-anchor', 'middle');
    txt.setAttribute('font-size', seg.s); txt.setAttribute('font-weight', '800');
    txt.setAttribute('letter-spacing', seg.s > 20 ? '-1' : '0');
    txt.setAttribute('font-family', '-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif');
    txt.setAttribute('transform', 'rotate('+mid+' '+tp[0].toFixed(2)+' '+tp[1].toFixed(2)+')');
    seg.t.forEach(function(ln, k){
      var ts = document.createElementNS(NS, 'tspan');
      ts.setAttribute('x', tp[0].toFixed(2));
      ts.setAttribute('dy', k === 0 ? String(-seg.s*0.14) : String(seg.s*0.92));
      if (k > 0) ts.setAttribute('font-size', seg.s*0.84);
      ts.textContent = ln;
      txt.appendChild(ts);
    });
    g.appendChild(txt);
  });

  function two(n){ n = String(n); return n.length < 2 ? '0'+n : n; }
  var c1 = document.getElementById('ilev-clock'), c2 = document.getElementById('ilev-bclock');
  var strip = document.getElementById('ilev-strip');
  var relojBanner = c2 ? c2.parentNode : null;
  var reloj = null;

  /* Al cumplirse la fecha NO se apaga nada: solo se retira el contador,
     para no mostrar un 00:00:00 muerto. El cierre de la campana es manual. */
  function retirarReloj(){
    if (reloj){ clearInterval(reloj); reloj = null; }
    if (strip) strip.style.display = 'none';
    if (relojBanner) relojBanner.style.display = 'none';
    if (banner && banner.classList.contains('is-on')) setTimeout(fitBanner, 60);
  }

  function tick(){
    var d = END - Date.now();
    if (d <= 0){ retirarReloj(); return; }
    var dias = Math.floor(d / 86400000);
    var t = two(Math.floor(d % 86400000 / 3600000))+':'+two(Math.floor(d%3600000/60000))+':'+two(Math.floor(d%60000/1000));
    if (dias > 0) t = dias + (dias === 1 ? ' día ' : ' días ') + t;
    if (c1) c1.textContent = t;
    if (c2) c2.textContent = t;
  }
  tick(); reloj = setInterval(tick, 1000);

  function bannerOn(){
    banner.classList.add('is-on');
    setTimeout(fitBanner, 60);
    window.addEventListener('resize', fitBanner);
  }
  function fitBanner(){
    var h = banner.offsetHeight;
    document.body.style.paddingTop = h + 'px';
    var cands = document.querySelectorAll('header, .site-header, [id^="shopify-section"], [data-js-header], .header');
    for (var i = 0; i < cands.length && i < 60; i++){
      var el = cands[i], cs = getComputedStyle(el);
      if ((cs.position === 'fixed' || cs.position === 'sticky') && (cs.top === '0px' || cs.top === 'auto')){
        if (!el.hasAttribute('data-ilev-shift')){ el.setAttribute('data-ilev-shift','1'); }
        el.style.top = h + 'px';
      }
    }
  }
  function bannerOff(){
    banner.classList.remove('is-on');
    document.body.style.paddingTop = '';
    document.querySelectorAll('[data-ilev-shift]').forEach(function(el){ el.style.top = ''; });
  }
  function hideAll(){ overlay.classList.remove('is-on'); bannerOff(); fabOff(); }

  /* boton flotante para volver a abrir la ruleta (fijo a media altura, borde izquierdo) */
  function fabOn(){ if (fab) fab.classList.add('is-on'); }
  function fabOff(){ if (fab) fab.classList.remove('is-on'); }
  function openWheel(){ fabOff(); overlay.classList.add('is-on'); }

  var spinning = false, won = false;

  function angleNow(){
    var m = getComputedStyle(g).transform;
    if (!m || m === 'none') return 0;
    var v = m.match(/matrix\(([^)]+)\)/);
    if (!v) return 0;
    var n = v[1].split(',').map(parseFloat);
    return ((Math.atan2(n[1], n[0]) * 180 / Math.PI) % 360 + 360) % 360;
  }

  function toKlaviyo(email){
    try{
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO, {
        method: 'POST',
        headers: { 'content-type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Ruleta Flash Agosto 2026',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: LIST } } }
        } })
      }).catch(function(){});
    }catch(e){}
  }

  function spin(ev){
    if (ev) ev.preventDefault();
    if (spinning || won) return;
    var f = document.getElementById('ilev-email'), e = document.getElementById('ilev-err');
    var email = (f.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)){ f.classList.add('is-err'); e.classList.add('is-on'); f.focus(); return; }
    f.classList.remove('is-err'); e.classList.remove('is-on');

    spinning = true;
    var btn = document.getElementById('ilev-spin');
    btn.disabled = true; btn.textContent = 'Girando…';

    toKlaviyo(email);
    store(KEY, 'won');

    var idx = WIN[Math.floor(Math.random() * WIN.length)];
    var center = idx*ARC + ARC/2;
    var jitter = (Math.random() - 0.5) * (ARC*0.5);
    var cur = angleNow();
    g.style.animation = 'none'; g.style.transition = 'none';
    g.style.transform = 'rotate(' + cur + 'deg)';
    void g.getBoundingClientRect();
    var want  = ((360 - center + jitter) % 360 + 360) % 360;
    var delta = ((want - cur) % 360 + 360) % 360;
    g.style.transition = 'transform 5.6s cubic-bezier(.15,.85,.22,1)';
    g.style.transform  = 'rotate(' + (cur + 360*6 + delta) + 'deg)';

    setTimeout(function(){
      document.getElementById('ilev-mail').textContent = email;
      card.classList.add('is-won');
      bannerOn();
      spinning = false; won = true;
    }, 5700);
  }

  function copy(btn){
    try{ if (navigator.clipboard) navigator.clipboard.writeText('FLASH'); }catch(e){}
    var old = btn.textContent;
    btn.textContent = 'Copiado'; btn.classList.add('is-done');
    setTimeout(function(){ btn.textContent = old; btn.classList.remove('is-done'); }, 2000);
  }

  document.getElementById('ilev-form').addEventListener('submit', spin);
  document.getElementById('ilev-copy').addEventListener('click', function(){ copy(this); });
  document.getElementById('ilev-bcopy').addEventListener('click', function(){ copy(this); });
  function dismiss(){
    overlay.classList.remove('is-on');
    if (!won){ store(KEY, 'closed:' + Date.now()); fabOn(); }
  }
  document.getElementById('ilev-x').addEventListener('click', dismiss);
  overlay.addEventListener('click', function(e){ if (e.target === overlay) dismiss(); });
  document.getElementById('ilev-bx').addEventListener('click', bannerOff);
  if (fab) fab.addEventListener('click', openWheel);

  var bases = document.getElementById('ilev-bases');
  document.getElementById('ilev-tyc').addEventListener('click', function(){ bases.classList.add('is-on'); });
  document.getElementById('ilev-bases-x').addEventListener('click', function(){ bases.classList.remove('is-on'); });
  bases.addEventListener('click', function(e){ if (e.target === bases) bases.classList.remove('is-on'); });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){ if (bases.classList.contains('is-on')) { bases.classList.remove('is-on'); } else { dismiss(); } }
  });

  /* ---------- arranque ---------- */
  function arrancar(){
    var SNOOZE = HORAS_SIN_MOLESTAR * 3600 * 1000;
    var state = store(KEY) || '';
    if (state === 'won'){
      card.classList.add('is-won'); won = true;
      bannerOn();
    } else if (state.indexOf('closed:') === 0 && Date.now() - Number(state.slice(7)) < SNOOZE){
      fabOn();   // la cerró sin girar: no reabrimos sola, dejamos el botón chico
    } else {
      fabOn();
      setTimeout(openWheel, SEGUNDOS_ANTES_DEL_POPUP * 1000);
    }
  }

  /* Listas o segmentos de Klaviyo excluidos (window.ILEV_RULETA_EXCLUIR).
     Esto usa la group membership API, que solo responde si la cuenta tiene
     Advanced KDP. Si no lo tiene, la llamada se queda callada: a los 2,5 s
     seguimos y la ruleta se muestra igual. Falla hacia mostrar, nunca hacia
     esconder por error. Solo funciona con navegador identificado. */
  var EX = String(window.ILEV_RULETA_EXCLUIR || '')
             .split(',')
             .map(function(s){ return s.trim(); })
             .filter(function(s){ return s; });

  if (EX.length && window.klaviyo && typeof window.klaviyo.getGroupMembership === 'function'){
    var resuelto = false;
    var seguir = function(){ if (!resuelto){ resuelto = true; arrancar(); } };
    var espera = setTimeout(seguir, 2500);
    try{
      Promise.resolve(window.klaviyo.getGroupMembership(EX)).then(function(r){
        if (resuelto) return;
        resuelto = true; clearTimeout(espera);
        if (r && r.length){ marcar(); return; }   /* está en la lista: no se muestra */
        arrancar();
      }).catch(function(){ clearTimeout(espera); seguir(); });
    }catch(e){ clearTimeout(espera); seguir(); }
  } else {
    arrancar();
  }
})();
